import styled from 'styled-components';

export const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #ebecec;
`;

export const DialogTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-contrast-black);
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: var(--color-neutral-500);
  padding: 4px 8px;
  border-radius: 4px;
  &:hover {
    background-color: var(--color-neutral-100);
  }
`;

export const DialogFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 24px;
  border-top: 1px solid #ebecec;
`;

/* Banner de job em execução */
export const RunningJobBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e8f4fd;
  border: 1px solid #b3d9f7;
  border-radius: 6px;
  padding: 10px 16px;
  margin-top: 12px;
  margin-bottom: 16px;
`;

export const RunningJobInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: #1a6fa8;
  flex: 1;
  min-width: 0;
`;

export const LiveLogMessage = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: #2c6e9e;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
`;

export const RunningStartTime = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: #1a6fa8;
  white-space: nowrap;
`;

export const RunningDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #1a6fa8;
  animation: pulse 1.5s infinite;

  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
  }
`;

export const ProgressWrapper = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`;

/* Filtros */
export const FiltersRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #ebecec;
`;

export const FilterItem = styled.div`
  min-width: 160px;
`;

export const StatusFilterLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: #9aa4ad;
  margin-bottom: 4px;
`;

export const StatusFilterSelect = styled.select`
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  color: #393939;
  background: white;
  cursor: pointer;
  min-width: 140px;

  &:focus {
    outline: none;
    border-color: var(--color-action-default);
  }
`;

export const FilterActions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

/* Tabela */
const colBase = `
  font-size: 13px;
  color: #393939;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-action-default);
  color: #ffffff;
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  padding: 8px 0;
  border-radius: 4px 4px 0 0;

  /* Garante que todos os filhos herdem a cor branca */
  & > * {
    color: #ffffff !important;
  }
`;

export const ColStart = styled.div`
  ${colBase}
  flex: 2;
`;

export const ColEnd = styled.div`
  ${colBase}
  flex: 2;
`;

export const ColDuration = styled.div`
  ${colBase}
  flex: 1;
  text-align: center;
`;

export const ColStatus = styled.div`
  ${colBase}
  flex: 1.5;
  text-align: center;
`;

export const ColExpand = styled.div`
  flex: 0 0 40px;
  text-align: center;
`;

export const ExecRow = styled.div`
  border-bottom: 1px solid #ebecec;
  background-color: ${(props) => {
    if (props.erro) return '#fff8f8';
    if (props.running) return '#f0f7ff';
    return 'white';
  }};

  &:nth-child(even) {
    background-color: ${(props) => {
      if (props.erro) return '#fff0f0';
      if (props.running) return '#e8f4fd';
      return '#f9f9f9';
    }};
  }
`;

export const RowMain = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;

  &:hover {
    background-color: #f0f4f8;
  }
`;

export const RowDetail = styled.div`
  padding: 12px 16px 16px;
  background-color: #fafafa;
  border-top: 1px dashed #ddd;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  color: ${(props) => {
    if (props.erro) return '#c64138';
    if (props.running) return '#1a6fa8';
    if (props.canceled) return '#c3913b';
    if (props.warn) return '#c3913b';
    return '#4a8c2a';
  }};
`;

export const StatusBadgeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ExpandIcon = styled.span`
  font-size: 12px;
  color: #9aa4ad;
  transition: transform 0.2s;
  display: inline-block;
  transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

/* Detalhes de erro */
export const ErrorSection = styled.div`
  margin-bottom: 12px;
`;

export const ErrorTitle = styled.div`
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: #9aa4ad;
  margin-bottom: 4px;
  margin-top: 8px;
`;

export const ErrorText = styled.div`
  font-size: 14px;
  color: #c64138;
  background-color: #fff0f0;
  border: 1px solid #f5c6c6;
  border-radius: 4px;
  padding: 8px 12px;
`;

export const StackTrace = styled.pre`
  font-size: 12px;
  color: #555;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow-y: auto;
`;

/* Logs de progresso */
export const LogsSection = styled.div``;

export const LogsTitle = styled.div`
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: #9aa4ad;
  margin-bottom: 6px;
`;

export const LogRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }
`;

export const LogDate = styled.span`
  color: #9aa4ad;
  min-width: 60px;
  font-size: 12px;
`;

export const LogLevel = styled.span`
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  min-width: 50px;
  color: ${(props) => {
    switch (props.nivel?.toLowerCase()) {
      case 'error': return '#c64138';
      case 'warn':
      case 'warning': return '#c3913b';
      case 'cancel': return '#c3913b';
      default: return '#4a8c2a';
    }
  }};
`;

export const LogMessage = styled.span`
  flex: 1;
  color: #393939;
`;

export const LogPercent = styled.span`
  font-weight: var(--font-weight-semibold);
  color: var(--color-action-default);
  min-width: 40px;
  text-align: right;
`;

/* Utilitários */
export const EmptyMessage = styled.div`
  text-align: center;
  padding: 32px;
  color: #9aa4ad;
  font-size: 14px;
`;

export const LoadingWrapper = styled.div`
  position: relative;
  height: 200px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
